export default "__VITE_ASSET__JY6OaXVD__"